import { addToWindowRef, getFromWindowRef } from '@avantia/client-and-server-utilities';
import { configureDataDogRum } from '@avantia/third-party-monitoring/configureDataDogRum';
import { configureGoogleAnalytics } from '@avantia/third-party-monitoring/configureGoogleAnalytics';
import { configureHotjar } from '@avantia/third-party-monitoring/configureHotjar';
import { extendEventLogger } from '../actions/eventActions';
import { HpClaimsClientConfiguration } from '../config/configurationTypes';
import { configureEventLogger } from '../engineClient/tools/eventLogger';
import { setupGtmEventHandler } from '../tools/gtmEventHandler';

export function configureThirdPartyFeatures(config: HpClaimsClientConfiguration): void {
  const {
    gtmEnabled,
    hotjarEnabled,
    hotjarId,
    hotjarTrackingCode,
    ddApplicationId,
    ddClientToken,
    ddCompressInTakeRequests,
    ddRumEnabled,
    ddRumSessionRecordingEnabled,
    ddServiceName,
    ddSessionReplaySampleRate,
    ddTrackResources,
    ddUsePartitionedCrossSiteSessionCookie,
    googleAnalyticsEnabled,
    environment,
    releaseVersion,
    gaTrackingId,
    answersKey,
    websiteEndpoint,
    websiteExternalUrl
  } = config;

  configureDataDogRum({
    ddAllowedTracingUrls: [websiteExternalUrl],
    ddApplicationId,
    ddClientToken,
    ddCompressInTakeRequests,
    ddRumEnabled,
    ddRumSessionRecordingEnabled,
    ddServiceName,
    ddSessionReplaySampleRate,
    ddTrackResources,
    ddUsePartitionedCrossSiteSessionCookie,
    environment,
    releaseVersion,
    ddDefaultPrivacyLevel: 'mask-user-input'
  });

  if (gtmEnabled) {
    setupGtmEventHandler();
  }

  configureGoogleAnalytics({ googleAnalyticsEnabled, gaTrackingId, addToWindowRef, getFromWindowRef });
  configureHotjar({ hotjarEnabled, hotjarId, hotjarTrackingCode });

  configureEventLogger({ answersKey, websiteEndpoint, extend: extendEventLogger });
}
